var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BLink',{staticClass:"mr-2",on:{"click":function($event){$event.preventDefault();return _vm.downloadFile.apply(null, arguments)}}},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),(_vm.text || _vm.name)?_c('span',{staticClass:"small",class:{'ml-3': _vm.icon !== null}},[_vm._v(_vm._s(_vm.text || _vm.name))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }